import React from "react";
import EntityApi from "../../api/EntityApi";
import ListChapter from "../../components/catalog/ListChapter";
import Button from "../../components/element/Button";
import ChapterFormModal from "../../modals/ChapterFormModal";
import MaterialCreateFormModal from "../../modals/MaterialCreateFormModal";
import { RollbackOutlined } from '@ant-design/icons';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faPlus, faRemove, faArrowCircleDown, faArrowCircleUp, faEdit} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";
import {
    HtmlDocIcon,
    ImageDocIcon,
    PdfDocIcon,
    TextDocIcon,
    VideoDocIcon,
    CodeDocIcon,
    SlideshowDocIcon,
    ExamIcon, UnknownDocIcon
} from "../../assets/icons";
import ModalConfirm from "../../components/main/ModalConfirm";
import Input from "../../components/element/Input";
import { Modal } from 'antd';
import TestingForm from "../testing/edit/TestingForm";
import InputUploadTesting from "../../components/element/InputUploadTesting";

const CourseMaterial = ({id}) => {

    const popperRef = React.useRef(null);
    const [ chapters, setChapters ] = React.useState([]);
    const [ isLoadingChapters, setLoadingChapters ] = React.useState(false);
    const [ isLoadingMaterials, setLoadingMaterials ] = React.useState(false);
    const [ isLoadMaterials, setLoadMaterials ] = React.useState(false);
    const [ chapterActive, setChapterActive ] = React.useState(0);
    const [ chapterTitle, setChapterTitle ] = React.useState('');
    const [ isOpenChapterForm, setOpenChapterForm ] = React.useState(false);
    const [ parentId, setParentId ] = React.useState(0);
    const [isPopperOpen, setIsPopperOpen] = React.useState(false);
    const [isSaveChapter, setIsSaveChapter] = React.useState(false);
    const [ isRemoveChapterOpen, setIsRemoveChapterOpen ] = React.useState(false);
    // Material
    const [ isOpenMaterialForm, setOpenMaterialForm ] = React.useState(false);
    const [ materialType, setMaterialType ] = React.useState('html');
    const [ materials, setMaterials ] = React.useState([]);
    const [ isRemoveOpen, setIsRemoveOpen ] = React.useState(false);
    const [ materialId, setMaterialId ] = React.useState(0);
    const [isOpenMove, setOpenMove] = React.useState(false);
    const [materialMoveTitle, setMaterialMoveTitle] = React.useState('');
    const [materialMoveId, setMaterialMoveId] = React.useState(0);
    // Testing
    const [ isOpenTesting, setOpenTesting ] = React.useState(false);
    const [ testingId, setTestingId ] = React.useState(0);

    React.useEffect(() => {

        if (id != undefined && id > 0) {

            EntityApi.get('private/product', id).then((data) => {
                if (data.content.item.chapters) {
                    setChapters(data.content.item.chapters);
                    setLoadingChapters(true);
                    data.content.item.chapters.forEach((item, index) => {
                        if (index == 0) {
                            setChapterActive(item.id);
                            setChapterTitle(item.title);
                        }
                    });
                }
            });

        }

    }, [isLoadingChapters])

    React.useEffect(() => {
        setLoadingMaterials(true);
        setMaterials([]);
        EntityApi.getBy('private/material', {
            filter: { chapter: chapterActive, product: id}
        }).then((data) => {
            setLoadingMaterials(false);
            if (data.content.items) {
                setMaterials(data.content.items);
            }
        });
    }, [chapterActive, isLoadMaterials]);

    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.composedPath().includes(popperRef.current)) {
                setIsPopperOpen(false);
            }
        }
        document.body.addEventListener('click', handleClickOutside);
        return () => {
            document.body.removeEventListener('click', handleClickOutside);
        }

    }, [])

    const addChapter = (id) => {
        setParentId(id);
        setOpenChapterForm(true);
    }

    const editChapter = () => {
        if (chapterActive > 0 && chapterTitle !== '') {
            EntityApi.post('private/chapter', chapterActive, {
                'title': chapterTitle,
                'parent': parentId,
                'product': id,
            }).then((data) => {
                setLoadingChapters(false);
                setIsSaveChapter(false);
            })
        }
    }

    const chapterSelect = (id, title) => {
        setChapterActive(id);
        setChapterTitle(title);
    }

    const addMaterial = (type) => {
        setMaterialType(type);
        setMaterialId(0);
        setOpenMaterialForm(true);
    }

    const openMaterial = (id, type) => {

        if (type === 'testing') {
            setMaterialType(type);
            setMaterialId(id);
            setOpenTesting(true);
            return true;
        }

        if (type == 'pdf' || type == 'image' || type == 'video') {
            type = 'file';
        }
        setMaterialType(type);
        setMaterialId(id);
        setOpenMaterialForm(true);
    }

    const removeMaterial = (id) => {
        setMaterialId(id);
        setIsRemoveOpen(true);
    }

    const removeMaterialConfirm = () => {
        if (materialId > 0) {
            setIsRemoveOpen(false);
            EntityApi.delete('private/material', materialId).then((data) => {
                setLoadMaterials(!isLoadMaterials);
            });
        }
    }

    const addTesting = () => {
        setTestingId(0);
        setOpenTesting(true);
    }

    const removeChapterConfirm = () => {
        if (chapterActive > 0) {
            setLoadingChapters(true);
            EntityApi.delete('private/chapter', chapterActive).then(() => {
                setLoadingChapters(false);
            });
            setIsRemoveChapterOpen(false);
            if (chapters[0]) {
                setChapterActive(chapters[0].id);
            } else {
                setChapterActive(0);
                setChapters([]);
                setChapterTitle('');
            }
        }
    }

    const downMaterial = (id) => {
        EntityApi.post('private/material/sort', id, {
            'direction': 'down'
        }).then((data) => {
            setLoadMaterials(!isLoadMaterials);
        })
    }

    const upMaterial = (id) => {
        EntityApi.post('private/material/sort', id, {
            'direction': 'up'
        }).then((data) => {
            setLoadMaterials(!isLoadMaterials);
        })
    }

    const openMoveMaterial = (id, title) => {
        setMaterialMoveId(id);
        setMaterialMoveTitle(title);
        setOpenMove(true);
    }

    const moveMaterial = (chapterId) => {
        if (chapterId > 0 && materialMoveId > 0) {
            EntityApi.post('private/material-content-move', materialMoveId, {
                chapter: chapterId,
            }).then((data) => {
                if (data.status === EntityApi.STATUS_SUCCESS) {
                    setLoadMaterials(!isLoadMaterials);
                    setOpenMove(false);
                } else {
                    alert('Ошибка переноса');
                }
            })
        } else {
            alert('Не выбран материал или глава');
        }
    }

    const renderIcon = (type) => {
        switch (type) {
            case 'html':
                return <HtmlDocIcon/>;
                break;
            case 'text':
                return <TextDocIcon/>;
                break;
            case 'pdf':
                return <PdfDocIcon/>;
                break;
            case 'image':
                return <ImageDocIcon/>;
                break;
            case 'video':
                return <VideoDocIcon/>;
                break;
            case 'code':
                return <CodeDocIcon/>;
                break;
            case 'slideshow':
                return <SlideshowDocIcon/>;
                break;
            case 'testing':
                return <ExamIcon/>;
                break;
            case 'file':
                return <UnknownDocIcon/>;
                break;
            default:
                <></>
        }
    }

    const chapterSort = (chapter, direction) => {
        EntityApi.post('private/chapter/sort', chapter, {
            'direction': direction
        }).then((data) => {
            setLoadingChapters(!isLoadingChapters);
        })
    }

    return <div className={"flex mt-6"}>
        <div className={"w-4/12"}>
            <div className={"card"}>
                {
                    !isLoadingChapters &&
                        <div className="app-preloader absolute opacity-50 z-50 grid h-full w-full place-content-center bg-slate-50 dark:bg-navy-900">
                            <div className="app-preloader-inner relative inline-block h-48 w-48"></div>
                        </div>
                }
                <div className={"p-4 sm:px-5"}>
                    <ul className={"space-y-1.5 font-inter font-medium"}>
                        {
                            chapters.length > 0 && chapters.map((chapter, index) =>
                                <React.Fragment key={chapter.id}>
                                    <ListChapter
                                        onUp={index > 0 ? () =>  chapterSort(chapter.id, 'down')  : null}
                                        onDown={index < chapters.length - 1 ? () =>  chapterSort(chapter.id, 'up')  : null}
                                        onClick={() => chapterSelect(chapter.id, chapter.title)} isSub={!!chapter.chapters} id={chapter.id} title={chapter.title} active={chapterActive === chapter.id ? 'active' : 'default' }/>
                                    {
                                        chapter.chapters && chapter.chapters.map((subchapter, subIndex) =>
                                            <ListChapter
                                                onUp={subIndex > 0 ? () =>  chapterSort(subchapter.id, 'down')  : null}
                                                onDown={subIndex < chapter.chapters.length - 1 ? () =>  chapterSort(subchapter.id, 'up')  : null}
                                                onClick={() => chapterSelect(subchapter.id, subchapter.title)} key={subchapter.id} isSub={false} id={subchapter.id} title={subchapter.title} active={chapterActive === subchapter.id ? 'active' : 'default' }/>
                                        )
                                    }
                                    <li><Button text={"Добавить подглаву"} onClick={() => addChapter(chapter.id)} type={"infoOutlineSmall"}/></li>
                                </React.Fragment>
                            )
                        }
                        <li><Button text={"Добавить главу"} onClick={() => addChapter(0)} type={"infoOutlineSmall"}/></li>
                    </ul>
                </div>
            </div>
        </div>
        { chapterActive > 0 &&
        <div className={"w-8/12 ml-4"}>
            <div className={"card p-4 lg:p-6"}>
                {
                    isLoadingMaterials &&
                        <div className="app-preloader absolute opacity-50 z-50 grid h-full w-full place-content-center bg-slate-50 dark:bg-navy-900">
                            <div className="app-preloader-inner relative inline-block h-48 w-48"></div>
                        </div>
                }
                <div className={"flex items-center space-x-1"}>
                    <div className={"w-1/12"}>
                        <Button onClick={() => setIsRemoveChapterOpen(true)} text={<FontAwesomeIcon icon={faRemove}/>} type={"errorOutline"}/>
                    </div>
                    { isSaveChapter &&
                        <div className={"w-1/12"}>
                            <Button onClick={() => editChapter()} text={"OK"} type={"primary"}/>
                        </div>
                    }
                    <div className={"w-6/12"}>
                        <Input type={"text"} value={chapterTitle} placeholder={""} onChange={(v) => { setIsSaveChapter(true); setChapterTitle(v);}} />
                    </div>
                    <div className="inline-flex">
                        <button ref={popperRef} onClick={(evt) => setIsPopperOpen(true)}
                                className="popper-ref btn h-8 w-8 rounded-full p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                            <FontAwesomeIcon icon={faChevronDown}/>
                        </button>
                        <div className={`popper-root${isPopperOpen ? ' show' : ''}`} style={{'position': 'absolute'}}>
                            <div
                                className="popper-box rounded-md border border-slate-150 bg-white py-1.5 font-inter dark:border-navy-500 dark:bg-navy-700">
                                <ul>
                                    <li>
                                        <div onClick={() => {
                                            addMaterial('text')
                                        }}
                                             className="flex h-8 items-center space-x-3 cursor-pointer px-3 pr-8 font-medium tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
                                            <FontAwesomeIcon icon={faPlus}/>
                                            <span> Добавить текстовый материал</span></div>
                                    </li>
                                    <li>
                                        <div onClick={() => addMaterial('html')}
                                             className="flex h-8 items-center space-x-3 cursor-pointer px-3 pr-8 font-medium tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
                                            <FontAwesomeIcon icon={faPlus}/>
                                            <span> Добавить веб-содержимое</span></div>
                                    </li>
                                    <li>
                                        <div onClick={() => addMaterial('file')}
                                             className="flex h-8 items-center space-x-3 cursor-pointer px-3 pr-8 font-medium tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
                                            <FontAwesomeIcon icon={faPlus}/>
                                            <span> Добавить файл (PDF, MP4, JPEG)</span></div>
                                    </li>
                                    <li>
                                        <div onClick={() => addMaterial('slideshow')}
                                             className="flex h-8 items-center space-x-3 cursor-pointer px-3 pr-8 font-medium tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
                                            <FontAwesomeIcon icon={faPlus}/>
                                            <span> Добавить слайд-шоу</span></div>
                                    </li>
                                    {/*<li>
                                        <div onClick={() => {}}
                                           className="flex h-8 items-center space-x-3 cursor-pointer px-3 pr-8 font-medium tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
                                            <FontAwesomeIcon icon={faPlus}/>
                                            <span> Добавить видео</span></div>
                                    </li>*/}
                                    <li>
                                        <div onClick={() => addMaterial('code')}
                                             className="flex h-8 items-center space-x-3 cursor-pointer px-3 pr-8 font-medium tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
                                            <FontAwesomeIcon icon={faPlus}/>
                                            <span> Добавить внешний код</span></div>
                                    </li>
                                    <li>
                                        <div onClick={() => {
                                            setMaterialType('testing');
                                            setMaterialId(0);
                                            addTesting();
                                        }}
                                             className="flex h-8 items-center space-x-3 cursor-pointer px-3 pr-8 font-medium tracking-wide outline-none transition-all hover:bg-slate-100 hover:text-slate-800 focus:bg-slate-100 focus:text-slate-800 dark:hover:bg-navy-600 dark:hover:text-navy-100 dark:focus:bg-navy-600 dark:focus:text-navy-100">
                                            <FontAwesomeIcon icon={faPlus}/>
                                            <span> Добавить тестирование</span></div>
                                    </li>
                                    <li>
                                        <InputUploadTesting chapterId={chapterActive} onLoading={setLoadingMaterials} onReload={() => setLoadMaterials(!isLoadMaterials)}/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    materials.length === 0 ?
                        <div className={"h-80"}></div> :
                        <div className={"mt-3"}>
                            {
                                materials.map(function (material, index) {
                                    return <div key={index} className={"flex mt-3"}>
                                        <div className={"flex h-10 w-10 items-center justify-center mr-4"}>
                                            {
                                                renderIcon(material.custom_type ? material.custom_type : material.type)
                                            }
                                        </div>
                                        <div className={"mr-4 w-full"}>
                                            <Button onClick={() => openMaterial(material.id, material.type)}
                                                    text={material.title}/>
                                        </div>
                                        <div className={"flex h-10 w-10 items-center justify-center mr-2"}>
                                            {
                                                index > 0 ?
                                                    <Button onClick={() => downMaterial(material.id)}
                                                            text={<FontAwesomeIcon icon={faArrowCircleUp}/>}
                                                            type={"info"}/>
                                                    :
                                                    <Button text={<FontAwesomeIcon icon={faArrowCircleUp}/>}
                                                            disabled={true} type={"defaultOutlineSmall"}/>
                                            }
                                        </div>
                                        <div className={"flex h-10 w-10 items-center justify-center mr-2"}>
                                            {
                                                index < materials.length - 1 ?
                                                    <Button onClick={() => upMaterial(material.id)}
                                                            text={<FontAwesomeIcon icon={faArrowCircleDown}/>}
                                                            type={"info"}/>
                                                    :
                                                    <Button text={<FontAwesomeIcon icon={faArrowCircleDown}/>}
                                                            disabled={true} type={"defaultOutlineSmall"}/>
                                            }
                                        </div>
                                        <div className={"flex h-10 w-10 items-center justify-center mr-2"}>
                                            <Button onClick={() => openMoveMaterial(material.id, material.title)}
                                                    text={<RollbackOutlined />} type={"default"}/>
                                        </div>
                                        <div className={"flex h-10 w-10 items-center justify-center mr-4"}>
                                            <Button onClick={() => removeMaterial(material.id)}
                                                    text={<FontAwesomeIcon icon={faRemove}/>} type={"error"}/>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                }
            </div>
        </div>
        }
        <ChapterFormModal parentId={parentId} productId={id} isOpen={isOpenChapterForm} onSuccess={() => setLoadingChapters(false)} onClose={() => setOpenChapterForm(false)}/>
        <MaterialCreateFormModal
            materialId={materialId}
            chapterId={chapterActive}
            productId={id}
            type={materialType}
            isOpen={isOpenMaterialForm}
            onSuccess={() => {setMaterialId(0);setLoadMaterials(!isLoadMaterials)}}
            onClose={() => {if (materialId === 0) setMaterialId(-1); else if (materialId === -1) setMaterialId(0); setOpenMaterialForm(false)}}
        />
        <ModalConfirm title={'Удаление материала'} text={'Вы действительно хотите удалить этот материал?'} cancelText={"Отменить"} confirmText={"Удалить"} onConfirm={removeMaterialConfirm}  isOpen={isRemoveOpen} onClose={() => setIsRemoveOpen(false)}/>
        <ModalConfirm title={'Удаление главы'} text={'Вы действительно хотите удалить эту главу? все материалы будут удалены'} cancelText={"Отменить"} confirmText={"Удалить"} onConfirm={removeChapterConfirm}  isOpen={isRemoveChapterOpen} onClose={() => setIsRemoveChapterOpen(false)}/>
        <Modal title={'Тестирование'} footer={null} open={isOpenTesting} width={'100%'} onCancel={() => setOpenTesting(false)}>
            <TestingForm
                materialId={materialId}
                productId={id}
                chapterId={chapterActive}
                onReloadList={() => {setLoadMaterials(!isLoadMaterials)}}
            />
        </Modal>
        <Modal title={'Перенос материала'} footer={null} open={isOpenMove} onCancel={() => setOpenMove(false)}>
            <div className={'mt-2 text-center'}>{materialMoveTitle}</div>
            {
                chapters.length > 0 && chapters.map((chapter, index) =>
                    <div>
                        <button className={'w-full rounded-lg bg-slate-150 py-2.5 text-left px-4 hover:bg-slate-100 mt-2'}
                                style={{fontWeight: 'bold'}} onClick={() => moveMaterial(chapter.id)}>
                            <span>{chapter.title}</span>
                        </button>
                        {
                            chapter.chapters && chapter.chapters.map((subchapter, subIndex) =>
                                <button className={'w-full rounded-lg bg-slate-150 py-2.5 text-left px-4 hover:bg-slate-100 mt-2'}  onClick={() => moveMaterial(subchapter.id)}>
                                <span>{subchapter.title}</span>
                            </button>)
                        }
                    </div>
                )
            }
        </Modal>
    </div>
}

export default CourseMaterial;
